import { AxiosRequestConfig, AxiosResponse } from 'axios';

import GetNewsResponse from '../../../Api/CRM/Responses/NewsResponse';
import GetPaginatedResponse from '../../../Api/CRM/Responses/PaginatedResponse';
import { API_CASINO_NEWS, API_CASINO_NEWS_LIMITED } from '../../../crm/casino/pages/Helpers/SiteApiUrls';
import AbstractCasinoSiteApi from '../AbstractCasinoSiteApi';

import CasinoGamesApi from './Modules/CasinoGamesApi';

class CasinoSiteApi extends AbstractCasinoSiteApi {
    public games = CasinoGamesApi;

    public getNews(
        getAllNews: boolean,
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<GetNewsResponse>> {
        const url = getAllNews ? API_CASINO_NEWS : API_CASINO_NEWS_LIMITED;
        return this.get(url, { ...config, params: { ...config.params, page } }).then(
            (response: AxiosResponse<GetPaginatedResponse<GetNewsResponse>> | AxiosResponse<GetNewsResponse[]>) => {
                if (Array.isArray(response.data)) {
                    return {
                        data: response.data,
                        current_page: 1,
                        last_page: 1,
                    } as GetPaginatedResponse<GetNewsResponse>;
                }

                return response.data;
            }
        );
    }
}

export default new CasinoSiteApi();
